import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const KEY = "dabkazari_newsletter_dismissed_v1";

export default function NewsletterPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try { if (localStorage.getItem(KEY)) return; } catch {}
    const t = setTimeout(() => setOpen(true), 6500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
    try { localStorage.setItem(KEY, "1"); } catch {}
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Welcome. Use code WELCOME10 for 10% off your first order.");
      close();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="newsletter-popup">
      <div className="bg-[#FDFBF7] max-w-3xl w-full grid md:grid-cols-2 relative">
        <button onClick={close} className="absolute top-3 right-3 text-[#1A1A1A]/70 hover:text-[#5C1A1B] transition-colors" data-testid="newsletter-close" aria-label="Close">
          <X strokeWidth={1.3} />
        </button>
        <div className="hidden md:block bg-[#F3EFEA] aspect-[3/4]">
          <img
            src="https://images.pexels.com/photos/17040892/pexels-photo-17040892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=600"
            alt="Dabkazari craftsmanship"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 md:p-12 flex flex-col justify-center">
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B] mb-3">First Order Reward</p>
          <h3 className="font-serif text-4xl leading-tight text-[#1A1A1A] mb-4">Enjoy 10% off your first heirloom.</h3>
          <p className="text-sm text-[#4A4A4A] leading-relaxed mb-6">
            Join the atelier list for private previews, mood boards, and early access to bridal drops.
          </p>
          <form onSubmit={submit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
              className="input-underline"
              data-testid="newsletter-email"
            />
            <button type="submit" className="btn-editorial" disabled={loading} data-testid="newsletter-submit">
              {loading ? "Sending…" : "Get My 10% Off"}
            </button>
            <button type="button" onClick={close} className="block text-[11px] uppercase tracking-nav text-[#7A7A7A] hover:text-[#5C1A1B] mt-2" data-testid="newsletter-skip">
              No thanks
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
